@use '@snowit/style/mixins';

.footer {
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1.5rem;

  @include mixins.media(sm) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
}

.confirmBtn {
  @include mixins.min-width-media(100%, sm, 10rem);

}

.cancelBtn {
  @include mixins.min-width-media(100%, sm, fit-content);
}
